<script setup lang="ts">
  import { ref, unref } from 'vue';
  import { SfDown } from '@sdesign/icons-vue';
  import { useRolesState } from '@/hook/useRoleState';
  import { fetchRoleRelationList, fetchDataBindList } from './service';
  import cookie from '@/utils/cookie';
  import { useTabBarStore } from 'sfapp'

  const { roles, currentRole } = useRolesState();

  const currentRoleRef = toRef(useRolesState(), 'currentRole');

  const visible = ref(false);
  const loading1 = ref(false);
  const loading2 = ref(false);
  const id1 = ref<string | undefined>(undefined);
  const id2 = ref<string | undefined>(undefined);
  const id3 = ref<string | undefined>(undefined);
  const arr2 = ref<{ label: string; value: string }[]>([]);
  const arr3 = ref<{ label: string; value: string }[]>([]);
  const arr1 = computed(() => {
    return roles.value.map((item) => ({ label: item.roleName, value: item.roleId }));
  });
  const currenrRoleName = computed(() => {
    return roles.value.find((item) => item.roleId === currentRole.value)?.roleName;
  });

  const onClickOutside = () => {
    visible.value = false;
  };
  const handleChangeRole = async (v: string) => {
    arr3.value = [];
    id3.value = undefined;
    id2.value = undefined;
    arr2.value = [];
    if (v) {
      loading1.value = true;
      const arr = await fetchRoleRelationList(v);
      arr2.value = arr?.map((it: any) => ({
        ...it,
        value: it.dataGroupId.toString(),
        label: it.dataGroupName,
      })) || [];
      loading1.value = false;
    }
  };
  const handleChangeRelation = async (v: string) => {
    id3.value = undefined;
    arr3.value = [];
    if (v) {
      loading2.value = true;
      const arr = await fetchDataBindList(v);
      arr3.value = arr?.map((it: any) => ({
        ...it,
        value: it.code,
        label: `[${it.code}]${it.name}`,
      })) || [];
      loading2.value = false;
    }
  };
  const handleConfirm = () => {
    sessionStorage.setItem('gw-bdus-rid', id1.value || '');
    sessionStorage.setItem('dataGroupId', id2.value || '');
    sessionStorage.setItem('vr-dept-code', id3.value || '');

    const curGroup: any = arr2.value.find((it: { value: string }) => it.value === id2.value);
    cookie('data-group-code', curGroup ? curGroup.dataGroupCode : null);

    cookie('vr-dept-code', id3.value || '');
    const tabBarStore = useTabBarStore()
    tabBarStore.clearTabListForUser()
    window.location.href = '/front/home';
  };
  const init = async () => {
    const t1 = sessionStorage.getItem('gw-bdus-rid') || roles.value?.[0]?.roleId;
    const t2 = sessionStorage.getItem('dataGroupId')?.toString();
    const t3 = sessionStorage.getItem('vr-dept-code');

    if (t1) {
      id1.value = t1;
      await handleChangeRole(t1);
    }
    if (t2 && arr2.value.some(item => item.value === t2)) {
      id2.value = t2;
      await handleChangeRelation(t2);
    }
    if (t3 && arr3.value.some(item => item.value === t3)) {
      id3.value = t3;
    }


    // 存个本地windows数据，防止互相覆盖
    (window as any)['gw-bdus-rid'] = id1.value;
    (window as any)['dataGroupId'] = id2.value;
    (window as any)['vr-dept-code'] = id3.value

    cookie('data-group-code', id2.value || '');
    cookie('vr-dept-code', id3.value || '');
  };
  init();

  watch(arr1, (newVal, oldVal) => {
    if ((!oldVal || oldVal?.length === 0) && newVal?.length > 0) {
      init();
    }
  })
</script>
<template>
  <el-popover :visible="visible" trigger="click" placement="bottom-end" width="530">
    <template #reference>
      <el-button :loading="!currenrRoleName" style="margin: 8px" size="small" @click="visible = !visible">
        {{ currenrRoleName }}
        <el-icon class="popup-content el-icon--right"><SfDown /></el-icon>
      </el-button>
    </template>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="popup-label">角色</div>
        <el-select v-model="id1" @change="handleChangeRole">
          <el-option v-for="item in arr1" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="8">
        <div class="popup-label">数据组</div>
        <el-select v-model="id2" @change="handleChangeRelation">
          <el-option v-for="item in arr2" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="8">
        <div class="popup-label">资源</div>
        <el-select v-model="id3">
          <el-option v-for="item in arr3" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="popup-btn-group">
      <el-button @click="onClickOutside">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-popover>
</template>

<style lang="less" scoped>
  .popup-label {
    font-size: 14px;
    margin-bottom: 4px;
    color: #333;
  }
  .popup-btn-group {
    margin-top: 12px;
    text-align: center;
  }
  .popup-content.el-icon--right.sf-olayout-icon {
    width: 12px;
    height: 12px;
    margin-left: 4px;
  }
</style>
